import React from "react";
import "./Highlights.css";
import Lollslauf from "../../Assets/0a51687b-bfa6-4a43-89ed-c427e57fe870.jpg";
import fourtyyears from "../../Assets/1cdd61bb-5ebd-4791-a224-7e8dd47b2c42.jpg"
import skateboard from "../../Assets/86c7eabe-68c9-42cc-8909-2085c33a405b.jpg"
function Highlights() {
  const highlights = [
    {
      title: "40 Jahre Jubiläum",
      description: "Ein viertägiges Fest mit tollen Veranstaltungen und Gästen.",
      image: fourtyyears,
    },
    {
      title: "Erste Teilnahme am Lolls Umzug",
      description: "Unsere Vereinsmitglieder organisierten zum Anlass des 40 jährigen Jubilaums, die Planung und Umsetzung der Teilnahme am Lollsumzuges.",
      image: Lollslauf,
    },
    {
      title: "Skateboardgruppe",
      description: "Elmar und Tom schließen sich dem Verein mit einer Skateboardgruppe an.",
      image: skateboard,
    },
  ];

  return (
    <section className="highlights" id="highlights">
      <div className="container">
        <h2 className="section-title">Highlights</h2>
        <div className="row">
          {highlights.map((highlight, index) => (
            <div className="col-md-4 col-12 mb-4" key={index}>
              <div className="highlight-card">
                <img
                  src={highlight.image}
                  alt={highlight.title}
                  className="highlight-image"
                />
                <div className="highlight-content">
                  <h5 className="highlight-title">{highlight.title}</h5>
                  <p className="highlight-description">{highlight.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Highlights;
